import { render, staticRenderFns } from "./WsBtn.vue?vue&type=template&id=3e159fd8&"
import script from "./WsBtn.vue?vue&type=script&lang=js&"
export * from "./WsBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports